import React from 'react';
import { View, Text, StyleSheet } from 'react-native';

export function CopyrightFooter() {
    const year = new Date().getFullYear();
    return (
        <View style={styles.container}>
            <Text style={styles.text}>
                © {year} EduWrite. All rights reserved.
            </Text>
            <Text style={styles.subtext}>
                EduWrite® is a trademark of EduWrite.{'\n'}
                Handwriting recognition is a learning aid only.
            </Text>
        </View>
    );
}

const styles = StyleSheet.create({
    container: {
        paddingVertical: 8,
        paddingHorizontal: 16,
        alignItems: 'center',
    },
    text: {
        fontSize: 11,
        color: '#94A3B8',
        textAlign: 'center',
    },
    subtext: {
        fontSize: 9,
        color: '#94A3B8',
        textAlign: 'center',
        marginTop: 2,
        lineHeight: 13,
    },
});
